<script setup lang="ts">
  import { useOrdering } from '@/composition/use-ordering';
  import ModalPosNewOrderInfo from './ModalPosNewOrderInfo.vue';
  import { onBeforeMount, provide } from 'vue';
  import ModalPosNewOrderMenu from './menu/ModalPosNewOrderMenu.vue';
  import ModalPosNewOrderSummary from './ModalPosNewOrderSummary.vue';
  import ModalPosNewOrderSummaryFooter from './ModalPosNewOrderSummaryFooter.vue';
  import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
  import { IOrder } from '@/interfaces/IOrder';
  import { ITable } from '@/interfaces/ITable';
  import { useMenuStore } from '@/composition/use-menu';
  import { OrderType } from '@/enums/OrderEnums';

  const props = defineProps<{
    order?: IOrder;
    table?: ITable;
    startingMode?: 'view' | 'edit';
  }>();

  const menuStore = useMenuStore();

  const orderHelper = useOrdering();
  provide('orderHelper', orderHelper);

  const breakpoints = useBreakpoints(breakpointsTailwind);
  const isSmallDevice = breakpoints.smallerOrEqual('md');

  onBeforeMount(() => {
    if (props.order) {
      orderHelper.setEditOrder(props.order);
    }
    if (props.table) {
      menuStore.setSelectedOrderType(OrderType.Seat);
      orderHelper.table.value = props.table;
    }
  });
</script>

<template>
  <div class="pos-new-order-modal">
    <div class="modal-inner">
      <div class="modal-body">
        <div class="order-info">
          <h3>Nuevo pedido</h3>
          <ModalPosNewOrderInfo :starting-mode="startingMode" />
          <ModalPosNewOrderSummary v-if="!isSmallDevice" class="summary" />
        </div>
        <div class="order-menu">
          <ModalPosNewOrderMenu class="tw-flex-1" />
        </div>
      </div>
      <div class="modal-footer">
        <ModalPosNewOrderSummaryFooter />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .pos-new-order-modal {
    @apply tw-flex tw-w-full;

    .modal-inner {
      @apply tw-flex tw-flex-col tw-w-full;

      .modal-header {
        @apply tw-flex-none tw-px-2 tw-py-1;
      }

      .modal-body {
        @apply tw-flex-1 tw-px-2 tw-py-1 tw-overflow-y-auto;
        @apply tw-flex tw-flex-col tw-space-y-4;
        @apply md:tw-flex-row md:tw-items-stretch md:tw-space-x-4 md:tw-space-y-0;

        .order-info {
          @apply tw-space-y-2 md:tw-w-80 tw-flex tw-flex-col;

          .summary {
            @apply tw-flex-1 tw-min-h-1;
          }
        }

        .order-menu {
          @apply tw-flex-1 tw-flex tw-flex-col;
          min-height: 10px;
          min-width: 10px;
        }
      }

      .modal-footer {
        @apply tw-flex-none tw-px-2 tw-py-1;
      }
    }
  }
</style>
